export default {
  stars: {
    id: 'review_page_stars',
    defaultMessage: '{intervals, html} stars',
  },
}
